module.exports = __webpack_public_path__ + "static/media/shareSuccess.580afbe1.png";